import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-card',
    templateUrl: 'card.component.html',
    styleUrls: ['card.component.scss']
})

export class AppCard {
    @Input() fill: "outline" | "filled" | "elevada" = "elevada";
}